import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { tracking } from '@ecs-helpers';
import { InjectionData, MODAL_CONTENT_TOKEN } from '@ecs-services/modal/modal.helper';
import { SearchStoreService } from '@ecs-services/search/search-store.service';
import { splitSearchString } from '@ecs-services/search/search.helper';
import { TranslatePipe } from '@ngx-translate/core';
import { TrackingService } from '@os-components';
import { SewButton, SewHeadline, SewInput } from '@sew/ui-components-angular/standalone';

@Component({
    selector: 'ecs-search-multiple',
    templateUrl: './search-multiple.component.html',
    styleUrls: ['./search-multiple.component.scss'],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        TranslatePipe,
        SewHeadline,
        SewInput,
        SewButton,
    ],
})
export class SearchMultipleComponent {
    public searchValue = '';
    public partsCount = 0;

    public splitSearchString = splitSearchString;

    public constructor(
        @Inject(MODAL_CONTENT_TOKEN)
        private injection: InjectionData<undefined>,
        private trackingService: TrackingService,
        private searchStoreService: SearchStoreService
    ) {}

    public search() {
        this.searchStoreService.search(this.searchValue);
        this.trackingService.trackEvent(tracking.step.search.multipleSearch.startSearchButton);
        this.injection.close();
    }
}
